module.exports = ['fatal', 'error', 'warn', 'info', 'debug'];
